 import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import ModalBox from "@/shared/components/modal-box/index.vue";
import { TrustAPI } from '@/shared/modules/trust-api';
import { Inject, Options, Vue } from "vue-property-decorator";
import { AppInsights } from '@/trust-admin-app/appInsights';
import ErrorIndicator from '@/shared/components/error-indicator/error-indicator';
import { NotesType, NoteView, PracticeRisk, PracticeRiskIndicator, PracticeView } from '@/shared/modules/typescript-trustapi-client/models';
import store from '@/trust-admin-app/store';
import { EventEmitter } from 'events';

@Options({
  components: {
    ModalBox,
    LoadingIndicator,
    ErrorIndicator,
  }
})
export default class AddEditModal extends Vue {
  private ai = new AppInsights;

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Inject({ from: 'noteType', default: [] })
  private noteType!: NotesType[];

  @Inject({ from: 'practiceRisks', default: [] })
  private practiceRisks!: PracticeRisk[];

  @Inject({ from: 'practiceRiskIndicators', default: [] })
  private practiceRiskIndicators!: PracticeRiskIndicator[];

  private showAddEditModal!: boolean;

  private isLoadingData = true;
  private errorLoadingData = false;
  private submitting = false;

  private formData: NoteView = {};

  created(): void {
    this.formData = {
      id: 0,
      notesType: { id: 0 },
      practiceNote: {
        practiceId: this.selectedPractice?.id,
        practiceRisk: { id: null as any},
        practiceRiskIndicator: { id: null as any}
      },
      content: null as any
    }
  }

  private async saveNote(): Promise<void> {
    try {
      this.submitting = true;
      await this.apiService.NotesApi?.apiV2NotesSaveNotePost(
        {
          id: 0,
          notesTypeId: 1,
          practiceId: this.formData.practiceNote.practiceId,
          practiceRiskId: this.formData.practiceNote.practiceRisk?.id,
          practiceRiskIndicatorId: this.formData.practiceNote.practiceRiskIndicator?.id,
          content: this.formData.content
        }
      );
      this.eventCtrl.emit('reload-practice-notes');
      this.eventCtrl.emit('show-snackbar', 'success', 'Note added successfully');
      this.closeModal();

    } catch(err) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Problem adding note');
    } finally {
      this.submitting = false;
    }
  }
  private cancelClicked(): void {
    this.closeModal();
  }

  private closeModal(): void {
    this.$emit('closeModal');
  }

  get validForm(): boolean {
    return true;
  }

  get isFormDirty(): boolean {
    return true;
  }

  get selectedPractice(): PracticeView {
    return store.getters.getSelectedPractice;
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }
  
}

